/* Mr. Zhu's — Product page interactions
 * Handles: thumbnail swap, variant pill selection, qty stepper,
 * dynamic price + add-to-cart label, hidden variant id sync.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function formatMoney(amount, locale, currency) {
    try {
      return new Intl.NumberFormat(locale || 'it-IT', {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    } catch (e) {
      return (currency || 'EUR') + ' ' + amount.toFixed(2);
    }
  }

  function initProduct(root) {
    var variants = parseJSON(root.querySelector('[data-product-variants-json]')) || [];
    var locale = root.getAttribute('data-locale') || 'it-IT';
    var currency = root.getAttribute('data-currency') || 'EUR';
    var addLabelTpl = root.getAttribute('data-add-label') || 'Add to cart \u00b7 @@PRICE@@';
    var soldOutLabel = root.getAttribute('data-sold-out-label') || 'Sold out';

    var mainImg = root.querySelector('[data-main-image]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    var pills = root.querySelectorAll('[data-variant-pill]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var qtyDec = root.querySelector('[data-qty-dec]');
    var qtyInc = root.querySelector('[data-qty-inc]');
    var priceEl = root.querySelector('[data-price]');
    var addBtn = root.querySelector('[data-add-btn]');
    var addLabelEl = root.querySelector('[data-add-label-text]');
    var hiddenVariant = root.querySelector('[data-variant-id-input]');

    var optionGroups = {};
    pills.forEach(function (pill) {
      var idx = pill.getAttribute('data-option-index');
      (optionGroups[idx] = optionGroups[idx] || []).push(pill);
    });

    function currentOptions() {
      var opts = [];
      Object.keys(optionGroups).sort().forEach(function (idx) {
        var active = optionGroups[idx].find(function (p) {
          return p.classList.contains('is-active');
        });
        opts.push(active ? active.getAttribute('data-option-value') : null);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        if (!v.options || v.options.length !== opts.length) return false;
        for (var i = 0; i < opts.length; i++) {
          if (opts[i] != null && v.options[i] !== opts[i]) return false;
        }
        return true;
      });
    }

    function currentQty() {
      var n = parseInt(qtyInput && qtyInput.value, 10);
      return isNaN(n) || n < 1 ? 1 : n;
    }

    function updateUI() {
      var opts = currentOptions();
      var variant = findVariant(opts) || variants[0];
      var qty = currentQty();
      if (!variant) return;

      if (hiddenVariant) hiddenVariant.value = variant.id;

      var unit = (variant.price || 0) / 100;
      var total = unit * qty;
      if (priceEl) priceEl.textContent = formatMoney(unit, locale, currency);

      if (addLabelEl) {
        addLabelEl.textContent = addLabelTpl.replace('@@PRICE@@', formatMoney(total, locale, currency));
      }

      if (addBtn) {
        if (variant.available === false) {
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.classList.add('is-sold-out');
          if (addLabelEl) addLabelEl.textContent = soldOutLabel;
        } else {
          addBtn.removeAttribute('disabled');
          addBtn.classList.remove('is-sold-out');
        }
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (!mainImg) return;
        var full = thumb.getAttribute('data-thumb-full');
        var srcset = thumb.getAttribute('data-thumb-srcset');
        var alt = thumb.getAttribute('data-thumb-alt');
        if (full) mainImg.setAttribute('src', full);
        if (srcset) mainImg.setAttribute('srcset', srcset);
        if (alt) mainImg.setAttribute('alt', alt);
      });
    });

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var idx = pill.getAttribute('data-option-index');
        (optionGroups[idx] || []).forEach(function (p) {
          p.classList.remove('is-active');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-pressed', 'true');
        updateUI();
      });
    });

    function setQty(n) {
      if (!qtyInput) return;
      var v = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
      qtyInput.value = String(v);
      updateUI();
    }
    if (qtyDec) qtyDec.addEventListener('click', function () { setQty(currentQty() - 1); });
    if (qtyInc) qtyInc.addEventListener('click', function () { setQty(currentQty() + 1); });
    if (qtyInput) {
      qtyInput.addEventListener('input', function () { updateUI(); });
      qtyInput.addEventListener('change', function () { setQty(currentQty()); });
    }

    updateUI();
  }

  ready(function () {
    document.querySelectorAll('[data-mz-product]').forEach(initProduct);
  });
})();
